import { EventEmitter, OnDestroy } from '@angular/core';
import { Component, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import {
  ITermsAndConditions,
  PrivacySettingsTermsAndConditionsDoc,
  RegulatoryDoc
} from '../../models/marketing-options.model';
import * as selector from '../../selectors';
import notify from 'devextreme/ui/notify';
import { HelpersService } from '../../../../core/services/helpers.service';

@Component({
  selector: 'app-regulatory',
  templateUrl: './regulatory.component.html',
  styleUrls: ['./regulatory.component.css']
})
export class RegulatoryComponent implements OnInit, OnDestroy {
  @Output() accept = new EventEmitter<void>();
  @Output() downloadDoc = new EventEmitter<string>();
  subscription: Subscription = new Subscription();
  regulatoryDocuments: RegulatoryDoc[];
  checked: boolean = true;
  allowAppNotifications: boolean;
  allowEmailNotifications: boolean;
  allowSMSNotifications: boolean;
  selectedValues: string[] = [];

  allowTnCs: boolean = false;
  countTnCsAccepted = [];
  countTnCObject: PrivacySettingsTermsAndConditionsDoc[];
  tcRegulation$: Observable<ITermsAndConditions>;

  constructor(
    private helpersService: HelpersService,
    private store: Store
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.tcRegulation$ = this.store.select(selector.getRegulatory);

    this.subscription.add(
      this.store.select(selector.getRegulatory).subscribe(reg => {
        if (reg !== undefined) {
          this.countTnCObject = reg.privacySettingsTermsAndConditionsDocs;
        }
      })
    );
  }

  switchOnTnCs(term, index) {
    if (this.countTnCsAccepted.includes(term.description)) {
      this.countTnCsAccepted = this.countTnCsAccepted.filter(item => item !== term.description);
    } else {
      this.countTnCsAccepted.push(term.description);
    }
  }

  acceptRegulatory() {
    if (this.countTnCsAccepted.length === this.countTnCObject.length) {
      this.accept.emit();
    } else {
      this.helpersService.notifyWarning(`Notice! Please accept all TnC's to continue`, 300, 3000);
    }
  }

  download(doc: string) {
    this.downloadDoc.emit(doc);
  }
}
